export default __webpack_public_path__ + "63dcc5a754384bb567ae3e9114343b6d.svg";